module.exports = __webpack_public_path__ + "421ccd0ff471b1cca65a994005ed1186.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-8.png
// module id = 2083
// module chunks = 0